import { useTranslation } from 'react-i18next'
import { LeaderboardItem } from './item'
import c from './assets/sass/table.module.scss'

export const LeaderboardTable = ({ entries = [], type = 'COINS', loading = false, currentUser = null }) => {
    const { t } = useTranslation()

    return (
        <div className={c.component}>
            <div className={c.header}>
                <span className={c.rank}>{t('pages.leaderboard.rank')}</span>
                <span className={c.player}>{t('pages.leaderboard.player')}</span>
                <span className={c.reward}>{t('pages.leaderboard.reward')}</span>
            </div>
            <div className={c.list}>
                {currentUser && (
                    <LeaderboardItem
                        rank={currentUser.rank}
                        firstName={currentUser.firstName}
                        photoUrl={currentUser.photoUrl}
                        score={currentUser.score}
                        reward={currentUser.reward}
                        rewardType={currentUser.rewardType}
                        caseName={currentUser.caseName}
                        caseImage={currentUser.caseImage}
                        type={type}
                        isMyRow
                    />
                )}
                {entries.map((entry, i) => (
                    <LeaderboardItem
                        key={entry.userId || i}
                        rank={entry.rank}
                        firstName={entry.firstName}
                        photoUrl={entry.photoUrl}
                        score={entry.score}
                        reward={entry.reward}
                        rewardType={entry.rewardType}
                        caseName={entry.caseName}
                        caseImage={entry.caseImage}
                        type={type}
                    />
                ))}
            </div>
        </div>
    )
}
